document.addEventListener("turbo:load", () => {
  document.querySelectorAll('a[href^="#"]').forEach(a => a.dataset.turbo = false);
})

document.addEventListener("turbo:before-render", () => {
  Chartkick.destroyAll();
});
